import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-b69de1d2"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "modal" };
const _hoisted_2 = { class: "qr-area" };
const _hoisted_3 = { class: "print-area" };
const _hoisted_4 = { ref: "qrCanvas" };
const _hoisted_5 = { class: "controls" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return ($props.visible)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "overlay",
            onClick: _cache[1] || (_cache[1] = _withModifiers(
            //@ts-ignore
            (...args) => ($options.close && $options.close(...args)), ["self"]))
        }, [
            _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("canvas", _hoisted_4, null, 512)
                    ])
                ]),
                _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("button", {
                        class: "print-btn",
                        onClick: _cache[0] || (_cache[0] =
                            //@ts-ignore
                            (...args) => ($options.printQrUsingIframe && $options.printQrUsingIframe(...args)))
                    }, "印刷")
                ])
            ])
        ]))
        : _createCommentVNode("", true);
}
